
import React from 'react';
import CategoryFilter from '@/components/CategoryFilter';
import SportsFilter from '@/components/SportsFilter';

interface FilterSidebarProps {
  categories: { id: string, name: string }[];
  sports: { id: string, name: string }[];
  selectedCategoryIds: string[];
  selectedSportId: string | null;
  onSelectCategory: (categoryId: string) => void;
  onSelectSport: (sportId: string | null) => void;
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({
  categories,
  sports,
  selectedCategoryIds,
  selectedSportId,
  onSelectCategory,
  onSelectSport
}) => {
  return (
    <div className="space-y-6">
      <CategoryFilter 
        categories={categories} 
        selectedCategoryIds={selectedCategoryIds} 
        onSelectCategory={onSelectCategory} 
      />
      <SportsFilter 
        sports={sports} 
        selectedSportId={selectedSportId} 
        onSelectSport={onSelectSport} 
      />
    </div>
  );
};

export default FilterSidebar;
